
(function () {
  'use strict';

  /* Hoisted out of snippets/card-product-slider.liquid (2026-08-25).
     It used to be emitted inline once per product card: ~10 KB x 36 cards
     = ~360 KB re-sent and re-parsed on EVERY filter request, because the
     facets Section Rendering API re-fetches the whole grid section.
     It is now one cached asset; cards are discovered from the DOM. */

  var PREFIX = 'CardSwiper-';

    // Native image gallery — no Swiper. On touch (mobile/tablet) the track is a
    // native scroll-snap scroller: swiping cycles this card's images and, once at
    // the last image, the scroll chains to the product row. On desktop the track
    // is not user-scrollable (CSS), so a wheel/two-finger over a card scrolls the
    // row; images are changed with the hover arrows. The progress bar tracks both.
  // Takes the scroller ELEMENT, not an id. The same card id can legitimately
  // appear twice on a page (e.g. a product rendered both in the grid and in the
  // header cart-drawer wishlist), and getElementById would resolve every
  // duplicate to the first copy, leaving the others permanently unbound.
  function setupCardGallery(scroller) {
      if (!scroller || scroller.dataset.galleryBound) return;
      scroller.dataset.galleryBound = 'true';

      var media = scroller.closest('.card-product-slider__media');
      // Scope the progress bar to this card for the same reason.
      var progressEl = media ? media.querySelector('.card-product-slider__progress') : null;
      var total = scroller.querySelectorAll('.swiper-slide').length || 1;
      var prevBtn = media ? media.querySelector('.card-nav-arrow--prev') : null;
      var nextBtn = media ? media.querySelector('.card-nav-arrow--next') : null;


      function currentIndex() {
        var w = scroller.clientWidth || 1;
        return Math.min(Math.max(Math.round(scroller.scrollLeft / w), 0), total - 1);
      }
      function refresh() {
        var idx = currentIndex();
        if (progressEl) progressEl.style.setProperty('--card-progress', (idx + 1) / total);
        // Hide the prev arrow at the first image and the next arrow at the last.
        if (prevBtn) prevBtn.classList.toggle('is-disabled', idx <= 0);
        if (nextBtn) nextBtn.classList.toggle('is-disabled', idx >= total - 1) ;
      }
      scroller.addEventListener('scroll', function () {
        window.requestAnimationFrame(refresh);
      }, { passive: true });

      // Desktop hover arrows (hidden on touch via CSS) — advance one image per click.
      if (total > 1) {
        var goToImage = function (delta) {
          var idx = Math.min(Math.max(currentIndex() + delta, 0), total - 1);
          scroller.scrollTo({ left: idx * scroller.clientWidth, behavior: 'smooth' });
        };
        if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goToImage(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function (e) { console.log('heelo');e.preventDefault(); e.stopPropagation(); goToImage(1); });
      }

      refresh();
    }

  // Bind every card currently in the DOM. setupCardGallery() is idempotent
  // (it early-returns on scroller.dataset.galleryBound), so this is safe to
  // call as often as we like.
  function bootAll() {
    var registry = (window.__cardSwiperRegistry = window.__cardSwiperRegistry || {});
    var scrollers = document.querySelectorAll('[id^="' + PREFIX + '"]');
    for (var i = 0; i < scrollers.length; i++) {
      var el = scrollers[i];
      var cardId = el.id.slice(PREFIX.length);
      try {
        setupCardGallery(el);
      } catch (err) {
        // Never let a single malformed card stop the rest from binding.
        if (window.console) console.error('card gallery init failed', cardId, err);
      }
      // The tab / image-collection sections call this when a hidden panel
      // becomes visible, to (re)bind the gallery and re-sync the progress bar.
      if (!registry[cardId]) {
        registry[cardId] = (function (id) {
          return function () {
            var nodes = document.querySelectorAll('[id="' + PREFIX + id + '"]');
            for (var n = 0; n < nodes.length; n++) setupCardGallery(nodes[n]);
          };
        })(cardId);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', bootAll);
  if (document.readyState !== 'loading') bootAll();
  document.addEventListener('shopify:section:load', bootAll);

  // The collection filters swap #ProductGridContainer's innerHTML via the
  // Section Rendering API, which fires no event. Watch for injected cards and
  // re-bind, coalescing bursts into a single pass.
  if (typeof MutationObserver === 'function') {
    var rebindQueued = false;
    var observer = new MutationObserver(function (records) {
      if (rebindQueued) return;
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) {
          rebindQueued = true;
          // setTimeout, not requestAnimationFrame: rAF is suspended while the
          // tab is hidden, which would leave cards from a background filter
          // permanently unbound. Timers still fire (throttled) when hidden.
          window.setTimeout(function () { rebindQueued = false; bootAll(); }, 0);
          return;
        }
      }
    });
    var startObserving = function () {
      observer.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) startObserving();
    else document.addEventListener('DOMContentLoaded', startObserving);
  }

  /* =========================
     QUICK ADD TOGGLE (POPUP)
  ========================== */
  // Guard in case the asset ends up included more than once.
  if (window.__quickAddInit) return;
  window.__quickAddInit = true;

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }


  // Adds a variant following Dawn's standard behaviour: ask the cart element
  // which sections to re-render, then hand the response to renderContents() so
  // that whichever cart UI the theme is configured for (drawer or notification
  // popup) opens. When the theme is in "page" mode there is no cart element on
  // the page, so we fall back to redirecting to the cart page — matching Dawn's
  // own product-form.js behaviour.
  async function performAdd(variantId) {
    var isCartPage = window.location.pathname === ((window.routes && window.routes.cart_url) || '/cart');
    var cart = getCartElement();
    var body = { id: Number(variantId), quantity: 1 };
    var refProps = window.IwasReferral && window.IwasReferral.lineProperties();
    if (refProps) body.properties = refProps;

    if (!isCartPage && cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });

    var data = await response.json();

    // Shopify returns { status, message, description } on failure.
    if (data.status) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }
      if (isCartPage) {
     window.location.reload();
    return data;
     }

    if (cart) {
    // Remove empty state
    cart.classList.remove('is-empty');

    // Fetch fresh sections (fixes first add on empty cart)
    const sectionIds = cart
      .getSectionsToRender()
      .map(section => section.id)
      .join(',');

    const sectionResponse = await fetch(
      `${window.location.pathname}?sections=${sectionIds}`
    );

    const sections = await sectionResponse.json();

    cart.renderContents({
      id: data.id,
      sections: sections
    });
    
  } else {
    window.location.href = routes.cart_url;
  }

    // Notify other Dawn components (cart bubble, analytics, etc.).
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'card-product-slider',
        productVariantId: variantId,
        cartData: data
      });
    }
    
    return data;
  }

  /* Surface cart errors (e.g. "You can only add N of this item to your
     cart.") on the card itself — /cart/add.js failures were previously only
     logged to the console, so the max-quantity message never reached the
     shopper. */
  function showCardError(fromEl, message) {
    var wrap = fromEl && fromEl.closest ? fromEl.closest('.card-product-slider-add') : null;
    var box = wrap ? wrap.querySelector('.card-atc-error') : null;
    if (!box) return;
    box.textContent = message || 'Could not add to cart';
    box.removeAttribute('hidden');
    window.clearTimeout(box.__cardErrTimer);
    box.__cardErrTimer = window.setTimeout(function () {
      box.setAttribute('hidden', '');
    }, 4000);
  }

  document.addEventListener('click', async function (e) {

    /* =========================
       QUICK ADD BUTTON CLICK
    ========================== */

    const btn = e.target.closest('.card-product-slider__quick-add');
    if (!btn) return;
   
    const productId = btn.getAttribute('data-product-id');
    if (!productId) return;

    // Scoped lookup: the same product can render several cards on one page
    // (two homepage rows, the cart-drawer wishlist tab, style-it-with), so
    // id="quick-add-<productId>" is NOT unique. getElementById returned the
    // first copy in the DOM — often the drawer's, up by the header wishlist
    // icon — and the popup opened there instead of on this card.
    const popup = btn.closest('.card-product-slider-add')?.querySelector('.quick-add-popup');

    /* =========================
       CASE 1: SINGLE VARIANT → DIRECT ADD
    ========================== */

    const singleVariantId = btn.getAttribute('data-single-variant-id');

    if (singleVariantId) {

      const loader = btn.querySelector('.card-product-loader');

      try {

        btn.classList.add('loading');
        btn.disabled = true;

        if (loader) loader.style.display = 'inline-block';

        await performAdd(singleVariantId);

      } catch (err) {

        console.error('Add to cart failed:', err);
        showCardError(btn, err && err.message);

      } finally {

        // The card stays on the page now (the drawer/notification opens instead
        // of navigating to /cart), so the spinner must be cleared explicitly.
        btn.classList.remove('loading', 'active');
        btn.disabled = false;
        if (loader) loader.style.display = 'none';
      }

      return;
    }

    /* =========================
       CASE 2: MULTI VARIANT → TOGGLE POPUP
    ========================== */

    if (!popup) return;

    const isOpen = popup.classList.contains('active');

    if (isOpen) {

      popup.classList.remove('active');
      btn.classList.remove('active');

      return;
    }

    // close all popups + buttons
    document.querySelectorAll('.quick-add-popup.active')
      .forEach(p => p.classList.remove('active'));

    document.querySelectorAll('.card-product-slider__quick-add.active')
      .forEach(b => b.classList.remove('active'));

    // open current
    popup.classList.add('active');
    btn.classList.add('active');

  });

  /* =========================
     VARIANT ADD TO CART
  ========================== */

  document.addEventListener('click', async function (e) {

    const variantBtn = e.target.closest('.variant-btn');
    if (!variantBtn) return;

    if (variantBtn.disabled) return;

    const variantId = variantBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    const loader = variantBtn.querySelector('.btn-loader');

    try {
        variantBtn.disabled = true;
        variantBtn.classList.add('loading');

        if (loader) loader.style.display = 'inline-block';

      await performAdd(variantId);

      const popup = variantBtn.closest('.quick-add-popup');
      if (popup) popup.classList.remove('active');

      // Same-card lookup (never document-wide by product id — ids repeat).
      const btn = popup?.closest('.card-product-slider-add')?.querySelector('.card-product-slider__quick-add');

      if (btn) btn.classList.remove('active');

    } catch (err) {
      console.error('Variant add failed:', err);
      showCardError(variantBtn, err && err.message);
    } finally {
      // Re-enable the variant button and hide its spinner. Sold-out variants
      // never reach here (they're skipped by the early disabled check above).
      variantBtn.disabled = false;
      variantBtn.classList.remove('loading');
      if (loader) loader.style.display = 'none';
    }

  });



  })();
